import { useReducedMotion } from 'framer-motion';
import type { RefObject } from 'react';
import { useCallback, useEffect, useRef } from 'react';

export interface UseScroller {
  sectionRefs: RefObject<Record<string, HTMLElement>>;
}

export const useScroller = (
  currentStepId: number,
  prevStep: RefObject<number>,
): UseScroller => {
  const sectionRefs = useRef<Record<string, HTMLElement>>({});
  const prefersReducedMotion = useReducedMotion();

  const onScroll = useCallback(
    (step: number) => {
      const nextElement = sectionRefs.current[step];
      if (nextElement) {
        window.scrollTo({
          top: nextElement.offsetTop - 96,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }
    },
    [prefersReducedMotion, sectionRefs],
  );

  useEffect(() => {
    if (currentStepId !== prevStep.current) {
      // scroll to section
      onScroll(currentStepId);
    }
    prevStep.current = currentStepId;
  }, [currentStepId, onScroll, prevStep]);

  return { sectionRefs };
};
